import React, { useState, useEffect } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  LabelList,
} from "recharts";
import { Card } from "react-bootstrap";

function CityBarChart() {
  const [citiesData, setCitiesData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch("mancata_vendita_dashboard.json");
        const data = await response.json();

        const provinceMap = {};

        data.SUD.localita.forEach((item) => {
          const regione = item.regione || "Sconosciuta";
          const valore = item.Valore ? parseFloat(item.Valore.replace(",", ".")) : 0;
          const numero = parseInt(item.numero_doc, 10) || 0;
        
          if (!provinceMap[regione]) {
            provinceMap[regione] = { regione, valore: 0, numero: 0 };
          }
        
          provinceMap[regione].valore += valore;
          provinceMap[regione].numero += numero;
        });
        
        const transformedData = Object.values(provinceMap).sort((a, b) => b.valore - a.valore);
        const topProvinces = transformedData.slice(0, 5); // Prendi le prime 5 province con più ordini
        
        setCitiesData(topProvinces);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, []);

  const formatToEuro = (amount) => {
    return new Intl.NumberFormat("it-IT", {
      style: "currency",
      currency: "EUR",
    }).format(amount);
  };

  const maxXValue =
  Math.max(...citiesData.map((dataPoint) => dataPoint.numero)) + 100;

  return (
    <Card className="ombra ordini-ora card-home border-light hover-effect">
      <div className="mt-1 mx-auto">
        <p className="text-title3 p-1 mt-2">
          ORDINI RICEVUTI - REGIONI
        </p>
      </div>
     <ResponsiveContainer width="100%" height="100%">
             <BarChart
               className="rounded"
               data={citiesData}
               layout="vertical"
               margin={{
                 top: 20,
                 right: 20,
                 left: 75,
                 bottom: 20,
               }}
             >
               <CartesianGrid />
               <XAxis
                 fill="black"
                 className="fw-bold"
                 style={{ fontSize: "0.6em" }}
                 type="number"
                 dataKey="valore"
                 domain={[0, maxXValue]}
                 tickFormatter={(value) => formatToEuro(value)}
               />{" "}
               <YAxis
                 dataKey="regione"
                 type="category"
                 hide="true"
                 fill="black"
                 className="fw-bold"
                 style={{ fontSize: "0.6em" }}
               />
               <Bar dataKey="valore" fill="red" name="Numero di Persone">
                 <LabelList
                   dataKey="valore"
                   formatter={(value) => formatToEuro(parseFloat(value))}
                   position="left"
                   fill="black"
                   className="fw-bold"
                   style={{ fontSize: "0.7em" }}
                 />
                 <LabelList
                   dataKey="regione"
                   position="insideLeft"
                   fill="black"
                   className="fw-bold"
                   style={{ fontSize: "0.6em" }}
                 />
                 <LabelList
                   dataKey="numero"
                   position="right"
                   fill="black"
                   className="fw-bold"
                   style={{ fontSize: "0.6em" }}
                 />
               </Bar>
               <Tooltip />
             </BarChart>
           </ResponsiveContainer>
    </Card>
  );
}

export default CityBarChart;
